// Vendor Libs
import {get, map} from 'lodash';

// Data
import actionsServiceCaller from '../lib/app/actions-service-caller';

// Config
import servicesFormConfig from '../../config/services-form-config';

const deleteRecordMiddleware = (store) => (next) => (action) => {
    const {dispatch} = store;
    next(action);
    const actions = {
        DELETE_RECORD_FULFILLED: () => handleFulfilled(dispatch, action),
        DELETE_RECORD_RESET: () => handleReset(dispatch, action),
        DELETE_RECORD_SUBMIT: () => submitDeleteRecord(dispatch, action),
    };

    if (actions[action.type]) {
        return actions[action.type]();
    }
};

function submitDeleteRecord(dispatch, {recordId, formName, successMessage}) {
    const dispatchFetched = (jsonResponse) => {
        dispatch({
            type: 'DELETE_RECORD_FULFILLED',
            formName,
            response: jsonResponse || successMessage,
        });
    };
    const dispatchError = (error) => {
        dispatch({
            type: 'DELETE_RECORD_REJECTED',
            error,
        });
    };
    const actionParams = {
        servicesConfig: servicesFormConfig[formName],
        dispatchFetched,
        dispatchError,
    };

    dispatch({
        type: 'DELETE_RECORD',
    });

    return Promise.resolve(actionsServiceCaller(actionParams, {}, recordId));
}

function handleFulfilled(dispatch, {formName}) {
    const results = map(get(servicesFormConfig, [formName, 'updateServiceDataKeys'], []), (servicesDataKey) => {
        dispatch({
            type: 'SEARCH_DATA_REFRESH',
            servicesDataKey,
            actionShouldFetch: true,
            selectRecord: false,
        });
    });

    return Promise.all(results);
}

function handleReset(dispatch, {formName, resetForm}) {
    let results = [];

    if (resetForm) {
        results = [
            ...map(get(servicesFormConfig, [formName, 'resetForms'], []), (formName) => {
                dispatch({
                    formName,
                    resetValues: true,
                    type: 'FORM_RESET',
                });
            }),
            ...map(get(servicesFormConfig, [formName, 'updateServiceDataKeys'], []), (servicesDataKey) => {
                dispatch({
                    actionShouldFetch: true,
                    selectRecord: true,
                    servicesDataKey,
                    type: 'SEARCH_DATA_REFRESH',
                });
            }),
        ];
    }

    return Promise.all(results);
}

export default deleteRecordMiddleware;
